import React from 'react';
import {Link} from 'react-router-dom';

const Menu = () => {
    return (
        <ul className="navbar-nav">
            <li className="logo">
                <Link to="/" className="nav-link">
                    <span className="nav-icon">[CC]</span>
                    <span className="link-text logo-text">Cesar Castro</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/apis" className="nav-link">
                    <span className="nav-icon">&lt;/&gt;</span>
                    <span className="link-text">API'S</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/blog" className="nav-link">
                    <span className="nav-icon">cat</span>
                    <span className="link-text">BLOG</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/contact" className="nav-link">
                    <span className="nav-icon">@msg</span>
                    <span className="link-text">CONTACT</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/social" className="nav-link">
                    <span className="nav-icon">./net</span>
                    <span className="link-text">SOCIAL MEDIAS</span>
                </Link>
            </li>
        </ul>
    )
}

export default Menu;
